// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__WZwgW","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1Cgeg"};